import { createContext } from "react";

const calculatorContext = createContext();

export default calculatorContext;